var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlightedCalendarView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1276_10603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5709 5.00007L29.5709 5H29.5625H26.5834H26.0834V5.5V7.33333V7.83333H26.5834H28.8334V27H4.1667V7.83333H6.4167H6.9167V7.33333V5.5V5H6.4167H3.43753V4.99993L3.42918 5.00007C3.14923 5.00475 2.87295 5.06453 2.61611 5.176C2.35927 5.28747 2.12691 5.44845 1.93229 5.64974C1.73768 5.85103 1.58462 6.08868 1.48187 6.34913C1.37967 6.60817 1.32923 6.88472 1.33337 7.16313V27.6702C1.32923 27.9486 1.37967 28.2252 1.48187 28.4842L1.94698 28.3007L1.48187 28.4842C1.58462 28.7447 1.73768 28.9823 1.93229 29.1836C2.12691 29.3849 2.35927 29.5459 2.61611 29.6573C2.87295 29.7688 3.14923 29.8286 3.42918 29.8333L3.42917 29.8333H3.43753H29.5625V29.8334L29.5709 29.8333C29.8508 29.8286 30.1271 29.7688 30.384 29.6573C30.6408 29.5459 30.8732 29.3849 31.0678 29.1836C31.2624 28.9823 31.4154 28.7447 31.5182 28.4842C31.6204 28.2252 31.6708 27.9486 31.6667 27.6702V7.16311C31.6708 6.8847 31.6204 6.60817 31.5182 6.34913C31.4154 6.08868 31.2624 5.85103 31.0678 5.64974L30.7083 5.99728L31.0678 5.64974C30.8732 5.44845 30.6408 5.28747 30.384 5.176C30.1271 5.06453 29.8508 5.00475 29.5709 5.00007Z",
    fill: "#FFC150",
    stroke: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 12.834H9.16671V14.6673H7.33337V12.834Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 12.834H14.6667V14.6673H12.8334V12.834Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 12.834H20.1667V14.6673H18.3334V12.834Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8334 12.834H25.6667V14.6673H23.8334V12.834Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 17.416H9.16671V19.2493H7.33337V17.416Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 17.416H14.6667V19.2493H12.8334V17.416Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 17.416H20.1667V19.2493H18.3334V17.416Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8334 17.416H25.6667V19.2493H23.8334V17.416Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 22H9.16671V23.8333H7.33337V22Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 22H14.6667V23.8333H12.8334V22Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 22H20.1667V23.8333H18.3334V22Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8334 22H25.6667V23.8333H23.8334V22Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 9.16732C9.40978 9.16732 9.64294 9.07074 9.81485 8.89883C9.98676 8.72692 10.0833 8.49377 10.0833 8.25065V2.75065C10.0833 2.50754 9.98676 2.27438 9.81485 2.10247C9.64294 1.93056 9.40978 1.83398 9.16667 1.83398C8.92355 1.83398 8.69039 1.93056 8.51849 2.10247C8.34658 2.27438 8.25 2.50754 8.25 2.75065V8.25065C8.25 8.49377 8.34658 8.72692 8.51849 8.89883C8.69039 9.07074 8.92355 9.16732 9.16667 9.16732Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 9.16732C24.0764 9.16732 24.3096 9.07074 24.4815 8.89883C24.6534 8.72692 24.75 8.49377 24.75 8.25065V2.75065C24.75 2.50754 24.6534 2.27438 24.4815 2.10247C24.3096 1.93056 24.0764 1.83398 23.8333 1.83398C23.5902 1.83398 23.357 1.93056 23.1851 2.10247C23.0132 2.27438 22.9166 2.50754 22.9166 2.75065V8.25065C22.9166 8.49377 23.0132 8.72692 23.1851 8.89883C23.357 9.07074 23.5902 9.16732 23.8333 9.16732Z",
    fill: "#FFC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9166 5.5H21.0833V7.33333H11.9166V5.5Z",
    fill: "#FFC150"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1276_10603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedCalendarView);
export default __webpack_public_path__ + "static/media/highlighted_calendar_view.f167ba29af59938e57e4dcad7d3145f6.svg";
export { ForwardRef as ReactComponent };